import { useCallback, useState } from 'react';

export function useClientRect(...deps: any[]) {
  const [rect, setRect] = useState<DOMRect>({ height: 0, width: 0 } as DOMRect);
  const ref = useCallback((node: HTMLElement) => {
    if (node !== null) {
      setRect(node.getBoundingClientRect());
    }
    // eslint-disable-next-line
  }, [...deps]);
  return [rect, ref] as const;
}
